"use strict";

module.exports = {
  READ: 'READ',
  EDIT: 'EDIT',
  MANAGE: 'MANAGE'
};